// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/store';
import Vuex from 'vuex';
import VueClipboard from 'vue-clipboard2';
import _ from 'lodash';
import Meta from 'vue-meta';
import VueAnalytics from 'vue-analytics';
// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';

Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(Meta);

// Raven
//     .config('https://1aca9d6541ea4e7ba0101881f289ac87@sentry.io/270809')
//     .addPlugin(RavenVue, Vue)
//     .install();

window.sounds = {};
window.sounds.sound1 = new Audio(require('@/assets/sounds/1.m4a'));
window.sounds.sound2 = new Audio(require('@/assets/sounds/2.m4a'));
window.sounds.copiedSound = new Audio(require('@/assets/sounds/copied.m4a'));
window.sounds.logoSound = new Audio(require('@/assets/sounds/logoSound.mp3'));

_.each(window.sounds, sound => {
    sound.volume = 0.5;
    // sound.addEventListener('canplaythrough', sound.play, false);
});

/* eslint-disable no-new */
let root = new Vue({
    router,
    store,
    render: h => h(App)
});

Vue.use(VueAnalytics, {
    id: 'UA-112385622-1',
    router,
    // debug: { enabled: true, trace: false, sendHitTask: true },
    // fields: {
    //     cookieDomain: 'none'
    // }
});

document.addEventListener('DOMContentLoaded', function () {
    root.$mount('#app');
});

Vue.use(Vuex);





// WEBPACK FOOTER //
// ./src/main.js